import React, { PropsWithChildren, Fragment, useEffect } from 'react';
import * as S from './styles';
import ScrollAreaContainer from '../ScrollAreaContainer';
import { Overlay } from '@/components/atoms/Overlay';
import { usePageScrollAreaHook } from '@/components/organisms/PageScrollArea/hook/usePageScrollAreaHook';

type DialogProps = PropsWithChildren<{
  open: boolean;
}>;

export default function Dialog(props: DialogProps) {
  const { open, children } = props;

  const { retornarValorMargemTopo } = usePageScrollAreaHook({
    isPageScrollArea: false,
  });

  const desabilitarScroll = () => {
    document.body.style.overflow = 'hidden';

    document.body.addEventListener('touchmove', preventDefault, {
      passive: false,
    });
    document.body.addEventListener('wheel', preventDefault, { passive: false });
  };

  const ativarScroll = () => {
    document.body.style.overflow = 'auto';

    document.body.removeEventListener('touchmove', preventDefault);
    document.body.removeEventListener('wheel', preventDefault);
  };

  const preventDefault = (e: WheelEvent | TouchEvent) => {
    e.preventDefault();
  };

  useEffect(() => {
    if (open) {
      desabilitarScroll();
    } else {
      ativarScroll();
    }
    return () => ativarScroll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  if (!open) return null;

  return (
    <Fragment>
      <Overlay
        $distanciaTopo={retornarValorMargemTopo('home')}
        $valorSobreposicaoDosDemaisComponentes={998}
      />
      {children ? (
        <ScrollAreaContainer orientacao="vertical">
          <S.Content>{children}</S.Content>
        </ScrollAreaContainer>
      ) : null}
    </Fragment>
  );
}
